
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-status-bar{
  display:flex;
  width:100%;
  flex-direction:column;
  background-color:var(--brand-secondary-4);
}

.se-status-bar--wrapper{
  display:flex;
  column-gap:2rem;
  flex-direction:column;
}

@media (min-width: 768px) and (max-width: 1280px){

.se-status-bar--wrapper{
    column-gap:1rem
}
  }

@media (min-width: 768px){

.se-status-bar--wrapper{
    flex-direction:row;
    padding:1.5rem 0
}
  }

.se-status-bar--content{
  display:flex;
  flex-direction:column;
  flex:1;
  padding:1.25rem 0;
}

.se-status-bar--description{
  font-family:var(--ff-dmsans);
  font-size:var(--fs-lg-mobile);
  color:var(--gray-800);
}

@media (min-width: 1280px){

.se-status-bar--description{
    font-size:var(--fs-lg)
}
  }

.se-status-bar--counter-slot{
  display:grid;
  flex:2;
  row-gap:2.25rem;
  padding:0 0 1rem 0;
}

@media (min-width: 1330px){

.se-status-bar--counter-slot{
    column-gap:3em
}
  }

@media (min-width: 1280px){

.se-status-bar--counter-slot{
    column-gap:2em
}
  }

@media (min-width: 1024px){

.se-status-bar--counter-slot{
    flex-direction:row;
    display:flex;
    justify-content:space-between;
    column-gap:1.25em
}
  }

@media (min-width: 768px){

.se-status-bar--counter-slot{
    padding:1.5rem 0;
    column-gap:1em;
    grid-template-columns:1fr 1fr
}
  }

[cloned-slot-name='counters']{
  display:flex;
  flex-direction:column;
  max-width:200px;
}

@media (min-width: 768px){

[cloned-slot-name='counters']{
    flex-direction:row
}
  }

[cloned-slot-name='image']{
  display:flex;
  height:100%;
}

[cloned-slot-name='image'] > *{
    width:100%;
  }

[cloned-slot-name='image'] img{
    width:100%;
    object-fit:cover;
    aspect-ratio:2 / 2;
  }

@media (min-width: 768px){

[cloned-slot-name='image'] img{
      aspect-ratio:3 / 1
  }
    }

.se-status-bar--heading{
  color:var(--gray-800);
}
`;